<template>
  <div>
    <el-card>
      <el-table
        :data="list.goodsList"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 1300px; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column
          prop="goodsName"
          label="商品名字"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="goodsDesc"
          label="描述"
          align="center"
          width="200"
        ></el-table-column>

        <el-table-column
          prop="price"
          label="价格"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="coverUrl"
          label="封面图"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <viewer>
              <img
                :src="row.coverUrl"
                alt=""
                style="height: 50px; width: auto"
              />
            </viewer>
          </template>
        </el-table-column>

        <el-table-column
          prop="goodsCount"
          label="商品数量"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="expressNumber"
          label="快递单号"
          align="center"
          width="150"
        >
          <template slot-scope="{ row }">
            <div>
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="upload(row)"
                v-if="row.expressNumber == null"
                >上传单号</el-button
              >
              <span @click="expressDetail(row)" style="cursor: pointer">{{
                row.expressNumber
              }}</span>
              <p
                style="color: #ddd; cursor: pointer"
                @click="expressDetail(row)"
                v-if="row.expressNumber != null"
              >
                (点击查看物流信息)
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsStatus" label="退款进度" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.goodsStatus == 1">正常</span>
            <span v-if="row.goodsStatus == 2">申请退货</span>
            <span v-if="row.goodsStatus == 3">拒绝退货</span>
            <span v-if="row.goodsStatus == 4">待上传快递号</span>
            <span v-if="row.goodsStatus == 5">退款中</span>
            <span v-if="row.goodsStatus == 6">退款完成</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="refuseReason"
          label="拒绝退款理由"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="returnReason"
          label="退款原因"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="returnNumber"
          label="退款物流"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="returnNumber"
          label="凭证图片"
          width="200"
          align="center"
        >
          <template slot-scope="{ row }">
            <viewer :images="row.returnImgList" style="display: flex; flex-wrap: wrap">
              <img
                :src="item.imgUrl"
                style="width: auto; height: 50px"
                v-for="(item, index) in row.returnImgList"
                :key="index"
              />
            </viewer>
            <!-- <viewer style="display: flex; flex-wrap: wrap">
              <img
                :src="item.imgUrl"
                style="width: auto; height: 50px"
                v-for="(item, index) in row.returnImgList"
                :key="index"
              />
            </viewer> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="returnPrice"
          label="退款金额"
          width="100"
          align="center"
        ></el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          width="120"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="agree(row, 1)"
                :disabled="row.goodsStatus != 5"
                >退款
              </el-button>
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="agree(row, 0)"
                :disabled="row.goodsStatus != 2"
                >拒绝退款</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="agree(row, 3)"
                :disabled="row.goodsStatus != 2"
                >同意退款
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 上传单号 -->
      <a-modal v-model="courierModel" title="上传快递单号" :footer="null">
        <el-form label-width="90px">
          <el-form-item label="单号">
            <el-col :span="10">
              <el-input
                v-model="expressNumber"
                placeholder="请输入内容"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="small" @click="okModel">确定</el-button>
      </a-modal>
      <!-- 物流信息 -->
      <el-dialog title="物流信息" :visible.sync="dialogTableVisible">
        <el-steps
          :space="200"
          :active="active"
          finish-status="success"
          process-status="wait"
          style="margin-bottom: 15px"
        >
          <el-step title="快递收件(揽件)"></el-step>
          <el-step title="在途中"></el-step>
          <el-step title="正在派件"></el-step>
          <el-step title="已签收"></el-step>
          <el-step title="派送失败"></el-step>
          <el-step title="疑难件"></el-step>
          <el-step title="退件签收"></el-step>
        </el-steps>
        <div>
          <p>
            <img :src="list.logo" alt="" style="height: 50px" />
            <span style="margin: 0 15px">{{ list.expName }}</span>
            <span>{{ list.number }}</span>
          </p>
        </div>
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp"
          >
            {{ activity.content }}
          </el-timeline-item>
        </el-timeline>
      </el-dialog>
    </el-card>

    <a-modal v-model="visibile" title="退款" :footer="null">
      <el-form label-width="90px">
        <el-form-item label="退款价格" v-if="ipt">
          <el-col :span="10">
            <el-input
              placeholder="请输入内容"
              v-model="returnPrice"
              type="number"
              id="number"
              clearable
              oninput="value=value.replace('-', '')"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="拒绝理由" v-if="!ipt">
          <el-col :span="10">
            <el-input
              placeholder="请输入内容"
              type="textarea"
              v-model="refuseReason"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="sure">确定</el-button>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
import { Message } from "element-ui";
export default {
  props: ["Detaildata"],
  data() {
    return {
      visibile: false,
      detailOpen: true,
      labelPosition: "left",
      active: 1,
      list: [],
      options: [
        {
          value: "0",
          label: "待付款",
        },
        {
          value: "1",
          label: "待发货",
        },
        {
          value: "2",
          label: "待收货",
        },
        {
          value: "3",
          label: "已完成",
        },
        {
          value: "4",
          label: "退还",
        },
      ],
      courierModel: false,
      expressNumber: "",
      scOrderGoodsId: "",
      dialogTableVisible: false,
      dialogFormVisible: false,
      visible: false,
      reverse: false,
      activities: [],
      listwl: [],
      ipt: "",
      id: "",
      returnPrice: "",
      refuseReason: "",
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    getList() {
      this.getAxios("/order/detail", {
        orderId: this.Detaildata.id,
      }).then((res) => {
        this.list = res.entity;
      });
    },
    upload(row) {
      this.courierModel = true;
      this.scOrderGoodsId = row.id;
    },
    okModel() {
      this.getAxios("/order/upload/expressNumber", {
        scOrderGoodsId: this.scOrderGoodsId,
        expressNumber: this.expressNumber,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.courierModel = false;
          this.getList();
        }
      });
    },
    expressDetail(row) {
      this.activities = [];
      this.getAxios("/order/c/wuliu", {
        scOrderGoodsId: row.id,
      }).then((res) => {
        if (res.success) {
          this.dialogTableVisible = true;
          this.listwl = res.entity;
          this.active = Number(res.entity.deliverystatus) + 1;
          res.entity.list.map((i) => {
            this.activities.push({
              content: i.status,
              timestamp: i.time,
            });
          });
        } else {
          this.dialogTableVisible = false;
          this.$message.error(res.message);
        }
      });
    },
    agree(row, val) {
      this.id = row.id;
      if (val == 1) {
        this.ipt = true;
        this.visibile = true;
      } else if (val == 0) {
        this.ipt = false;
        this.visibile = true;
      } else {
        this.getAxios("/order/agree/refund", {
          scOrderGoodsId: this.id,
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.getList();
          } else {
            this.$notify({
              message: res.message,
              type: "error",
              duration: 0,
              customClass: "aabb",
            });
          }
        });
      }
    },
    sure() {
      if (this.ipt == true) {
        this.agreeList();
      } else {
        this.noagreeList();
      }
      this.getList();
      this.visibile = false;
    },
    // 退款
    agreeList() {
      this.getAxios("/order/refund", {
        scOrderGoodsId: this.id,
        returnPrice: this.returnPrice,
      }).then((res) => {
        this.returnPrice = "";
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$notify({
            message: res.message,
            type: "error",
            duration: 0,
            customClass: "aabb",
          });
        }
      });
    },
    // 拒绝退款
    noagreeList() {
      this.getAxios("/order/refuse/refund", {
        scOrderGoodsId: this.id,
        refuseReason: this.refuseReason,
      }).then((res) => {
        this.refuseReason = "";

        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$notify({
            message: res.message,
            type: "error",
            duration: 0,
            customClass: "aabb",
          });
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    Detaildata(newVal, oldVal) {
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-upload {
  width: 200px;
  height: auto;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
  img {
    width: 100%;
    height: auto;
  }
}
/deep/ .el-form-item {
  width: 100%;
}
/deep/ .el-form-item__content {
  width: 100%;
}
/deep/ .ant-modal {
  width: 600px !important;
}
</style>